import React from 'react';
import CompanyFeatures from './components/CompanyFeatures/CompanyFeatures';
import AllFeatures from './components/AllFeatures/AllFeatures';
import styles from './FeaturesList.module.scss';

const FeaturesList = ({ companyId, companyName }) => {
    return (
        <div className={styles.wrapper}>
            <CompanyFeatures companyId={companyId} companyName={companyName} />
            <AllFeatures />
        </div>
    );
};

export default FeaturesList; 